// extracted by mini-css-extract-plugin
export default {"anchor":"CardAnchor_anchor__hgISi","fullWidth":"CardAnchor_fullWidth__6m7mB"};